import React, { useEffect, useRef } from "react";
import { UseMutationResult } from "react-query";
import { Box, CenterSpinner, CustomCard, NoData } from "ui-components";
import { parseHtml } from "../../../../utils/parse-html";
import { match } from "ts-pattern";
import { HtmlRequest } from "..";
import styled from "styled-components";
import { Colors } from "@blueprintjs/core";
import HtmlIframe from "../../../../components/html-iframe";

const CompanyWebsitePage = ({
  companyID,
  getHtmlByUrlMutation,
}: {
  companyID: string | undefined;
  getHtmlByUrlMutation: UseMutationResult<any, unknown, HtmlRequest, unknown>;
}) => {
  if (!companyID && !getHtmlByUrlMutation?.variables?.url) {
    return <NoData description={"Please select any ccompany"} title={"No Web Page Found"} icon={"warning-sign"} />;
  }
  return (
    <WebsiteContainer>
      {match(getHtmlByUrlMutation)
        .with({ status: "loading" }, () => <CenterSpinner />)
        .with({ status: "idle" }, () => <CenterSpinner />)
        .with({ status: "error" }, () => (
          <NoData
            description={"Web Page Loading Failed! | Please Try Another Page"}
            title={"Unauthorized Web Page"}
            icon={"warning-sign"}
          />
        ))
        .with({ status: "success" }, (response: any) => {
          if (!response?.data?.html) {
            return <NoData title={"No Web Page Found"} icon={"warning-sign"} />;
          }
          let webPage = parseHtml(response?.data?.html);
          return <HtmlIframe parsedHtml={webPage} />;
        })
        .exhaustive()}
    </WebsiteContainer>
  );
};

const WebsiteContainer = styled.div`
  border-top: ${({ theme: { darkMode } }) =>
    `1px solid ${darkMode ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY1}`};
  padding-top: 10px;
  margin: 0 -20px;
  padding-left: 20px;
  padding-right: 20px;
`;

export default CompanyWebsitePage;
